<script setup>
import {ref, reactive, onMounted, onBeforeMount, onUnmounted, nextTick, computed} from "vue";
import { VueCal } from 'vue-cal'
import 'vue-cal/style'
import moment from "moment"
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import {
  addServiceProviderSchedule, deleteServiceProviderSchedule,
  detailServiceProviderSchedule, editServiceLocation,
  lisServiceProviderAvailableByServiceItemId, lisServiceProviderAvailableDates
} from "@/api/serviceProviderSchedule/serviceProviderSchedule.js";
import { lisServiceProvider } from "@/api/serviceProvider/serviceProvider.js";
import {getRoute} from "@/hooks/getRoute.js";
import {disabledEndDate} from "@/hooks/dateUtils.js";
import {listServiceLocation} from "@/api/serviceLocation/serviceLocation.js";
import {editAppointmentOrder, listAppointmentOrder} from "@/api/appointment/appointment.js";
import {serviceItemOrderStateEnum} from "@/enum/serviceItemOrderStateEnum.js"
import {listServiceItemDetail} from "@/api/serviceItem/serviceItem.js";
import {listServicePhotography} from "@/api/servicePhotographer/servicePhotographer.js";
import {userTokenStore} from "@/store/store.js";
import axios from "axios";
/*获取路由信息，带参则为修改*/
const {route} = getRoute()
// 访问的模块: 1-排班日历 2-订单列表;默认1
const currentShow = ref(1)

onBeforeMount(async () => {
  dialogForm.serviceItemId = route.query.serviceItemId
  formData.serviceItemId = route.query.serviceItemId
  dialogForm.serviceItemType = route.query.serviceItemType
  formData.serviceItemType = route.query.serviceItemType
  // await handleGetDetail()
})

onMounted(async () => {
  // setInterval(() => {
  //   config.now = new Date();
  // }, 1000 * 10)
  if (route.query.serviceItemId) {
    if(formData.serviceItemType == 'PHOTOGRAPHY') {
      await handleGetPhotographyList()
      await handleGetServicePhotographyList()
    } else if(formData.serviceItemType == 'THERAPY') {
      await handleGetHotel()
      await handleGetTherapistList("")
    }
    await handleGetCal()
    await handleGetServiceLocationList("init")
    await handleSearch()
  } else {
    ElMessage.error("获取排班信息失败")
  }
})

// 获取服务项目详情信息
// const handleGetDetail = async () => {
//   try {
//     loading.value = true
//     const res = await listServiceItemDetail(dialogForm.serviceItemId)
//     console.log("ress======", moment(res.startTime).format('YYYY-MM-DD'))
//     config.viewDate = moment(res.startTime).format('YYYY-MM-DD')
//     loading.value = false
//   } catch (e) {
//     console.log(e)
//     loading.value = false
//   }
// }

onUnmounted(() => {

})

// 是否编辑状态
const isEdit = ref(false)
// 加载状态
const loading = ref(false)

/*排班弹窗相关*/
// 弹窗锚点
const dialogFormRef = ref()
// 添加/编辑排班弹窗打开状态
const open = ref(false)
// 弹窗表单
const dialogForm = reactive({
  startScheduleDate: null,
  endScheduleDate: null,
  scheduleDate: null,
  startHour: null,
  endHour: null,
  locationId: null,
  photographyId: null,
  providerId: null,
  providerName: null,
  serviceItemId: null,
  serviceItemType: null,
  providerScheduleId: null
})
// 排班日期校验规则
const checkScheduleDate = (rule, value, callback) => {
  if (isEdit.value) {
    if (!dialogForm.scheduleDate) {
      return callback(new Error("请选择排班日期"))
    }
  } else {
    if (!dialogForm.startScheduleDate) {
      return callback(new Error("请选择排班开始日期"))
    }
    if (!dialogForm.endScheduleDate) {
      return callback(new Error("请选择排班结束日期"))
    }
  }
  callback()
}
// 排班时间校验规则
const checkScheduleTime = (rule, value, callback) => {
  if (!dialogForm.startHour) {
    return callback(new Error("请选择排班开始时间"))
  }
  if (!dialogForm.endHour) {
    return callback(new Error("请选择排班结束时间"))
  }
  callback()
}
// 弹窗表单规则
const dialogRulesTherapy = {
  scheduleDate: [
    {required: true, validator: checkScheduleDate, trigger: "change"}
  ],
  scheduleTime: [
    {required: true, validator: checkScheduleTime, trigger: "change"}
  ],
  locationId: [
    {required: true, message: "请选择酒店", trigger: "change"}
  ],
  providerId: [
    {required: true, message: "请选择理疗师", trigger: "change"}
  ],
}
const dialogRulesPhotography = {
  scheduleDate: [
    {required: true, validator: checkScheduleDate, trigger: "change"}
  ],
  scheduleTime: [
    {required: true, validator: checkScheduleTime, trigger: "change"}
  ],
  photographyId: [
    {required: true, message: "请选择服务摄影师", trigger: "change"}
  ],
  providerId: [
    {required: true, message: "请选择摄影师", trigger: "change"}
  ],
}
// 关闭弹窗表单
const handleCloseDialog = async () => {
  open.value = false
  await handleClearDialog()
}
// 清空弹窗表单缓存
const handleClearDialog = async () => {
  open.value = false
  isEdit.value = false
  dialogForm.startScheduleDate = null
  dialogForm.endScheduleDate = null
  dialogForm.scheduleDate = null
  dialogForm.startHour = null
  dialogForm.endHour = null
  dialogForm.locationId = null
  dialogForm.photographyId = null
  dialogForm.providerId = null
  dialogForm.providerName = null
  dialogForm.providerScheduleId = null
}
// 处理增加/编辑排班表单提交
const handleSubmitDialog = () => {
  dialogFormRef.value.validate(async valid => {
    if (valid) {
      // 处理结束时间
      if (isEdit.value) {
        let param = {
          scheduleDate: dialogForm.scheduleDate,
          startHour: dialogForm.startHour,
          endHour: moment(moment().format("YYYY-MM-DD") + " " + dialogForm.endHour).add(59, "second").format("HH:mm:ss"),
          providerId: dialogForm.providerId,
          locationId: dialogForm.locationId,
          photographyId: dialogForm.photographyId,
          serviceItemId: dialogForm.serviceItemId,
        }
        await editServiceLocation(dialogForm.providerScheduleId, param)
      } else {
        let param = {
          startScheduleDate: dialogForm.startScheduleDate,
          endScheduleDate: dialogForm.endScheduleDate,
          startHour: dialogForm.startHour,
          endHour: moment(moment().format("YYYY-MM-DD") + " " + dialogForm.endHour).add(59, "second").format("HH:mm:ss"),
          providerId: dialogForm.providerId, // 理疗师/摄影师ID
          locationId: dialogForm.locationId, // 服务地点ID
          photographyId: dialogForm.photographyId, // 服务摄影ID
          serviceItemId: dialogForm.serviceItemId // 服务项目ID
        }
        await addServiceProviderSchedule(param)
      }
      ElMessage.success(isEdit.value ? "编辑排班成功" : "添加排班成功")
      await handleCloseDialog()
      await handleGetCal()
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}
// 处理删除排班
const handleRemoveSchedule = async () => {
  try {
    loading.value = true
    await deleteServiceProviderSchedule(dialogForm.providerScheduleId)
    ElMessage.success("排班删除成功")
    await handleCloseDialog()
    await handleGetCal()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

/*日历相关*/
// 日历锚点
const calendarEl = ref(null)
/**
* @name vue-cal配置
 * @author XNHOTARU
 * @param {String} events[index].id 排班id
 * @param {String} events[index].start 开始时间
 * @param {String} events[index].end 结束时间
 * @param {String} events[index].providerId 理疗师Id
 * @param {String} events[index].title 理疗师名称
 * @param {String} events[index].deletable 是否可以删除
 * @param {String} events[index].schedule 日历排序，作为酒店区分，举例：1为喜来登，2为皇冠假日，以此类推
 * @param {String} events[index].disabled 是否被预定(自定义值)
 * */
const config = reactive({
  view: "day", // 默认展示的日期单位
  views: ["day", "week"], // 可展示的日期单位
  hideWeekends: false, // 是否隐藏周末
  locale: "zh-cn", // 语言
  time: true,
  now: false, // 当前时间
  events: [], // 排班
  schedules: [],
  selectedDate: null,
  viewDate: null, // view为day时展示的日期
})
// 双击日历
const handleDblClick = ({ event }) => {
  console.log("click event", event)
  if (event.disabled) {
    ElMessage.error("此时间段已被预订，不允许修改")
    return
  }
  open.value = true
  isEdit.value = true
  // 数据缓存到dialogForm
  dialogForm.startScheduleDate = moment(event.start).format("YYYY-MM-DD")
  dialogForm.endScheduleDate = moment(event.end).format("YYYY-MM-DD")
  dialogForm.scheduleDate = moment(event.start).format("YYYY-MM-DD")
  dialogForm.startHour = moment(event.start).format("HH:mm")
  dialogForm.endHour = moment(event.start).add(59, "minute").format("HH:mm")
  dialogForm.locationId = event.locationId
  dialogForm.photographyId = event.photographyId
  dialogForm.providerId = event.providerId
  dialogForm.providerName = event.title
  dialogForm.serviceItemId = event.serviceItemId
  dialogForm.providerScheduleId = event.id
}
// 酒店列表加载状态
const hotelLoading = ref(false)
// 酒店列表
const hotelList = ref([])
// 酒店颜色枚举
const hotelTxtColorEnum = ['blue', 'green', 'orange', 'red']
// 查询酒店信息
const handleGetHotel = async (key) => {
  try {
    hotelLoading.value = true
    let param = {
      page: 1,
      pageSize: 100
    }
    const res = await listServiceLocation(param, {locationName: key ? key : null});
    hotelList.value = res.list
    hotelList.value.map((item, index) => {
      item.color = hotelTxtColorEnum[index % 4]
    })
    // 酒店详情映射到日历
    config.schedules = hotelList.value
    hotelLoading.value = false
  } catch (e) {
    console.log(e)
    hotelLoading.value = false
  }
}
// 服务摄影列表加载状态
const servicePhotographyLoading = ref(false)
// 服务摄影列表
const servicePhotographyList = ref([])
// 查询服务摄影信息
const handleGetServicePhotographyList = async () => {
  try {
    servicePhotographyLoading.value = true
    let param = {
      page: 1,
      pageSize: 100
    }
    const res = await listServicePhotography(param, { photographyName: '' });
    servicePhotographyList.value = res.list
    servicePhotographyList.value.map((item, index) => {
      item.color = hotelTxtColorEnum[index % 4]
    })
    // 服务摄影详情映射到日历
    config.schedules = servicePhotographyList.value
    servicePhotographyLoading.value = false
  } catch (e) {
    console.log(e)
    servicePhotographyLoading.value = false
  }
}
// 理疗师列表
const therapistList = ref([])
// 理疗师列表加载状态
const therapistLoading = ref(false)
// 查询理疗师信息
const handleGetTherapistList = async (key) => {
  try {
    therapistLoading.value = true
    let param = {
      page: 1,
      pageSize: 100
    }
    const res = await lisServiceProvider(param, {providerType: "THERAPIST", name:  key ? key : null});
    therapistList.value = res.list
    therapistLoading.value = false
  } catch (e) {
    console.log(e)
    therapistLoading.value = false
  }
}
// 摄影师列表
const photographyList = ref([])
// 摄影师列表加载状态
const photographyLoading = ref(false)
// 查询摄影师信息
const handleGetPhotographyList = async (key) => {
  try {
    photographyLoading.value = true
    let param = {
      page: 1,
      pageSize: 100
    }
    const res = await lisServiceProvider(param, {providerType: "PHOTOGRAPHER", name:  key ? key : null});
    photographyList.value = res.list
    photographyLoading.value = false
  } catch (e) {
    console.log(e)
    photographyLoading.value = false
  }
}
// 服务项目与名称
const serviceItemName = ref(null)
// 查询日历信息
const handleGetCal = async () => {
  try {
    loading.value = true
    const res = await detailServiceProviderSchedule(dialogForm.serviceItemId)
    console.log(res)
    serviceItemName.value = res.name
    nextTick(() => {
      // 处理酒店列表
      let tempEvents = []
      res.providerScheduleList.map(item => {
        let tempItem = {}
        let scheduleList = formData.serviceItemType == 'THERAPY' ? hotelList.value : servicePhotographyList.value
        let schedule = Number(scheduleList.findIndex(schedule => {
          if(formData.serviceItemType == 'THERAPY') {
            return schedule.locationId === item.locationId
          } else {
            return schedule.photographyId === item.photographyId
          }
        })) + 1

        tempItem.id = item.providerScheduleId
        tempItem.serviceItemId = item.serviceItemId
        tempItem.providerId = item.providerId
        tempItem.locationId = item.locationId
        tempItem.photographyId = item.photographyId
        tempItem.start = item.startTime
        tempItem.end = moment(item.startTime).add(59, "minute").add(59, "second").format("YYYY-MM-DD HH:mm:ss")
        tempItem.title = item.providerName
        tempItem.schedule = schedule
        tempItem.disabled = !(item.state === "UNRESERVED")
        tempItem.backgroundColor = !(item.state === "UNRESERVED") ? "#f4f4f5" : handleColor(tempItem.providerId)
        if (tempItem.disabled) tempItem.color = "#909399"
        tempEvents.push(tempItem)
      })
      config.events = tempEvents
    })
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 选中的属性值颜色区分
const handleColor = (item) => {
  const enumList = ['#ff6666d9', 'primary', '#57cea9cc', '#fd9c42d9']
  return enumList[simpleHash(item) % 4]
}
// 使用哈希函数对id编码
const simpleHash = (input) => {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash += input.charCodeAt(i);  // 获取字符的 UTF-16 编码值并累加
  }
  return hash;
};
// 获取日期
const handleGetDate = (date) => {
  return moment(date).date()
}
// 处理修改模式下自动填写结束时间
const handleAutoEnterEndHour = () => {
  if (isEdit.value) {
    console.log("dialogForm.startHour", dialogForm.startHour)
    const time = moment(dialogForm.startHour, 'HH:mm:ss') // 解析时间字符串
    // console.log("time.add(59, 'minute').format('HH:mm')", time.add(59, 'minute').format('HH:mm'))
    dialogForm.endHour = time.add(59, 'minute').format('HH:mm')
    console.log("dialogForm.endHour", dialogForm.endHour)
  }
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const headers = ref([
  {title: '订单编号', key: 'orderId', width: "120px", nowrap: true},
  {title: '预约人名', key: 'contactName', width: "150px", nowrap: true},
  {title: '预约人电话', key: 'contactPhone', width: "250px", nowrap: true},
  {title: '商家支付订单号', key: 'paymentNo', width: "250px", nowrap: true},
  {title: '服务地点', key: 'locationName', width: "150px", nowrap: true},
  {title: '房间号', key: 'roomNumber', width: "150px", nowrap: true},
  {title: '订单时间', key: 'orderTime', width: "150px", nowrap: true},
  {title: '服务时间', key: 'scheduleDate', width: "150px", nowrap: true},
  {title: '服务人员', key: 'providerName', width: "150px", nowrap: true},
  {title: '联系电话', key: 'providerPhone', width: "150px", nowrap: true},
  {title: '订单状态', key: 'orderState', width: "150px", nowrap: true},
  {title: '操作', key: 'controls', width: "100px", fixed: true},
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*搜索功能*/
// 表单数据
const formData = reactive({
  serviceItemId: null,
  serviceItemType: null,
  keyword: null,
  locationId: null,
  startTime: null,
  endTime: null,
  providerId: null,
  orderState: null
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    const res = await listAppointmentOrder(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.keyword = null
  formData.locationId = null
  formData.startTime = null
  formData.endTime = null
  formData.providerId = null
  formData.orderState = null
  handleSearch('btnSearch')
}
// 订单状态枚举
const serviceItemOrderState = serviceItemOrderStateEnum

/*服务地点搜索条件相关*/
// 服务地点列表
const serviceLocationData = ref()
// 服务地点加载状态
const serviceLocationLoading = ref(false)
// 服务地点搜索条件
const serviceLocationKey = ref()
// 服务地点总条数
const serviceLocationTotal = ref(0)
// 服务地点分页组件锚点
const YTTablePaginationServiceLocationRef = ref()
// 获取服务地点列表
const handleGetServiceLocationList = async (type) => {
  await nextTick(async () => {
    if (type === 'search') YTTablePaginationServiceLocationRef.value?.resetPage()
    try {
      serviceLocationLoading.value = true
      let param = {
        page: type === 'init' ? 1 : YTTablePaginationServiceLocationRef.value.getPage(),
        pageSize: type === 'init' ? 5 : YTTablePaginationServiceLocationRef.value.getPageSize(),
      }
      const res = await listServiceLocation(param, {locationName: serviceLocationKey.value})
      serviceLocationData.value = res.list
      serviceLocationTotal.value = Number(res.total)
      serviceLocationLoading.value = false
    } catch(e) {
      console.log("e", e)
      serviceLocationLoading.value = false
    }
  })
}
// 处理选择服务地点
const handleSelectServiceLocation = (e) => {
  formData.locationId = e
  console.log("e", e)
}
// 服务地点翻页
const handleChangeServiceLocationPage = () => {
  handleGetServiceLocationList()
}
// 处理点击服务地点下拉列表
const handleClickSelect = (e) => {
  // 下拉展示菜单时重新请求商家列表
  if (e) {
    handleGetServiceLocationList('search')
  }
}

/*开始时间、结束时间搜索条件相关*/
// 处理日期格式
const handleDateFormat = (date) => {
  return moment(date).format('YYYY-MM-DD')
}
// 处理选择器开始日期选择
const handleSelectDate = (date) => {
  formData.startTime = handleDateFormat(date)
  // 校验结束日期是否小于开始日期
  if (moment(formData.startTime).isAfter(moment(formData.endTime))) {
    formData.endTime = null
  }
}
// 处理选择器结束日期选择
const handleSelectEndDate = (date) => {
  formData.endTime = handleDateFormat(date)
}

/*服务人员搜索条件相关*/
const handleSelectProvider = (e) => {
  formData.providerId = e
  console.log("e", e)
}

/*订单状态搜索条件相关*/
const handleSelectOrderState = (e) => {
  formData.orderState = e
  console.log("e", e)
}

/*编辑订单弹窗相关*/
// 编辑订单表单锚点
const orderFormRef = ref()
// 编辑订单弹窗状态
const openOrder = ref(false)
// 订单弹窗表单
const orderForm = reactive({
  orderId: null,
  roomNumber: null,
  changeRoomNumber: null,
  providerId: null,
  providerName: null,
  changeProviderId: null,
  changeProviderName: null,
  orderState: null,
  contactName: null,
  locationId: null,
  locationName: null,
  scheduleDate: null,
  startHour: null,
  endHour: null,
  providerScheduleId: null
})
// 订单弹窗校验规则
const orderRules = {

}
// 清除订单弹窗缓存
const handleClearOrderForm = () => {
  orderForm.orderId = null
  orderForm.roomNumber = null
  orderForm.changeRoomNumber = null
  orderForm.providerId = null
  orderForm.providerName = null
  orderForm.changeProviderId = null
  orderForm.changeProviderName = null
  orderForm.orderState = null
  orderForm.contactName = null
  orderForm.locationId = null
  orderForm.locationName = null
  orderForm.scheduleDate = null
  orderForm.startHour = null
  orderForm.endHour = null
  orderForm.providerScheduleId = null
  availableTimes.value = []
  availableDates.value = []
}
// 可用日期列表
const availableDates = ref([])
// 可用时间列表
const availableTimes = ref([])
const formattedTimes = computed(() =>
    availableTimes.value.map((t) => ({
      startHour: moment(t.startHour, "HH:mm:ss").format("HH:mm"),
      endHour: moment(t.endHour, "HH:mm:ss").format("HH:mm"),
    }))
);
// 处理编辑订单信息
const handleEditOrder = async (item) => {
  orderForm.orderId = item.orderId
  orderForm.roomNumber = item.roomNumber
  orderForm.providerId = item.providerId
  orderForm.providerName = item.providerName
  orderForm.orderState = item.orderState
  orderForm.contactName = item.contactName
  orderForm.locationId = item.locationId
  orderForm.locationName = item.locationName
  orderForm.scheduleDate = item.scheduleDate
  orderForm.startHour = item.startTime
  orderForm.endHour = item.endTime
  orderForm.providerScheduleId = item.providerScheduleId
  try {
    const res = await lisServiceProviderAvailableDates(dialogForm.serviceItemId)
    availableDates.value = res.map(item => item.date)
    let param = {
      locationId: orderForm.locationId,
      scheduleDate: moment(orderForm.scheduleDate).format("YYYY-MM-DD"),
    }
    const res2 = await lisServiceProviderAvailableByServiceItemId(dialogForm.serviceItemId, param)
    availableTimes.value = res2.providerScheduleList
  } catch (e) {
    console.log(e)
  }
  openOrder.value = true
}
// 处理订单弹窗关闭
const handleCloseOrder = () => {
  openOrder.value = false
  orderFormRef.value.resetFields()
  handleClearOrderForm()
}
// 处理订单弹窗提交表单
const handleSubmitOrder = async () => {
  try {
    let param = {
      orderId: orderForm.orderId,
      roomNumber: orderForm.changeRoomNumber,
      providerId: orderForm.changeProviderId,
      orderState: orderForm.orderState,
      scheduleDate: moment(orderForm.scheduleDate).format('YYYY-MM-DD'),
      startHour: orderForm.startHour,
      endHour: orderForm.endHour,
      providerScheduleId:  orderForm.providerScheduleId,
      locationId: orderForm.locationId
    }
    await editAppointmentOrder(param)
    ElMessage.success("修改成功")
    handleCloseOrder()
    handleSearch('btnSearch')
    handleGetCal()
  } catch (e) {
    console.log(e)
  }
}
// 处理弹窗服务开始时间改变
const handleStartTimeChange = (e) => {
  if (!orderForm.startHour) return orderForm.endHour = null
  orderForm.endHour = moment(moment().format("YYYY-MM-DD") + " " + orderForm.startHour).add(59, "minute").format("HH:mm")
  const time = moment(moment().format("YYYY-MM-DD") + " " + orderForm.startHour).format("HH:mm:SS")
  const target = availableTimes.value.find(t => t.startHour === time)
  console.log("target", target)
  orderForm.changeProviderId = target.providerId
  orderForm.providerScheduleId = target.providerScheduleId
}
// 处理弹窗服务日期改变
const handleScheduleDateChange = async () => {
  orderForm.startHour = null
  orderForm.endHour = null
  try {
    let param = {
      locationId: orderForm.locationId,
      scheduleDate: moment(orderForm.scheduleDate).format("YYYY-MM-DD"),
    }
    const res = await lisServiceProviderAvailableByServiceItemId(dialogForm.serviceItemId, param)
    availableTimes.value = res.providerScheduleList
  } catch (e) {
    console.log(e)
  }
}
// 限制订单列表编辑弹窗服务时间的日期选择
const disabledDate = (time) => {
  if (availableDates.value.length === 0) return true; // 未加载完前禁用全部
  const dateStr = moment(time).format("YYYY-MM-DD")
  // 只允许出现在 availableDates 中的日期
  return !availableDates.value.includes(dateStr)
}
// 处理服务地点改变
const handleLocationChange = () => {
  orderForm.scheduleDate = null
  orderForm.startHour = null
  orderForm.endHour = null
}

/*下载报表相关*/
// 处理下载订单列表
const handleDownloadList = async (item) => {
  ElMessage.warning("下载中...");
  await downloadFile(
      `${
          import.meta.env.VITE_API_URL
      }/appointment/order/export/${formData.serviceItemId}`,
      {}, // 请求体数据
      `${serviceItemName.value}订单-${moment().format(
          "YYYY-MM-DD_HHmmss"
      )}.csv` // 默认文件名
  );
};
/**
 * 自定义文件名的下载函数
 * @param {string} url - 完整接口URL
 * @param {Object} requestData - 请求体数据
 * @param {string} customFilename - 自定义文件名
 */
const downloadFile = async (url, requestData = {}, customFilename) => {
  try {
    const token = userTokenStore().token;
    const response = await axios.post(url, requestData, {
      responseType: "blob",
      headers: {
        Authorization: token.tokenValue,
        "Login-Type": token.loginType,
        "Content-Type": "application/json",
      },
    });

    // 创建下载链接
    const blob = new Blob([response.data]);
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", customFilename); // 使用传入的自定义文件名
    document.body.appendChild(link);
    link.click();

    // 清理
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    }, 100);

    return true;
  } catch (error) {
    console.error("文件下载失败:", error);
    ElMessage.error("文件下载失败");
    return false;
  }
};
</script>

<template>
  <div class="container_box">
    <div style="text-align: left;font-size: 24px;font-weight: 500">{{serviceItemName}}</div>
    <v-divider style="margin: 20px 0;"/>
    <div class="flex_bt mg_b_2">
      <div>
        <v-btn color="success" @click="open = true" v-if="currentShow === 1">
          <template v-slot:default>
            <div class="flex_bt">
              <img
                  style="width: 14px; height: 14px; margin-right: 4px"
                  src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/plus.svg"
              />
              <span>添加排班</span>
            </div>
          </template>
        </v-btn>
      </div>
      <div>
        <v-btn class="mg_r_1" :disabled="currentShow === 1" color="primary" @click="currentShow = 1">排班日历</v-btn>
        <v-btn :disabled="currentShow === 2" color="primary" @click="currentShow = 2">订单列表</v-btn>
      </div>
    </div>
    <div class="w-100" v-show="currentShow === 1">
      <vue-cal style="height: 600px;" ref="calendarEl" watch-real-time v-bind="config" @event-Dblclick="handleDblClick">
        <template #weekday-heading="{ label, id, date }">
          <div class="flex_center">
            <div class="mg_r_1" style="width: 26px;height: 26px;line-height: 26px;font-size: 18px;background-color:#dae4f5;border-radius: 50%">{{handleGetDate(date)}}</div>
            <div style="font-size: 11px;">{{ label }}</div>
          </div>
        </template>
        <template v-if="formData.serviceItemType == 'THERAPY'" #schedule-heading="{ schedule, view }">
          <div :style="`color: ${schedule.color};font-weight: 500;width: 100%`" :title="`${schedule.locationName}`">{{ schedule.locationShortName }}</div>
        </template>
        <template v-if="formData.serviceItemType == 'PHOTOGRAPHY'" #schedule-heading="{ schedule, view }">
          <div :style="`color: ${schedule.color};font-weight: 500;width: 100%`" :title="`${schedule.photographyName}`">{{ schedule.photographyShortName }}</div>
        </template>
      </vue-cal>
    </div>
    <div class="w-100" v-show="currentShow === 2">
      <v-row justify="center">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="tableData"
              :loading="loading"
              :items-per-page="$globalPageSize"
              :no-data-text="'没有更多数据了~'"
              hover
          >
            <template v-slot:loading>
              <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
            </template>

            <template v-slot:top>
              <v-form>
                <v-container>
                  <v-row justify="center">
                    <v-col cols="1.5">
                      <v-text-field
                          v-model="formData.keyword"
                          placeholder="请输入关键字"
                          label="关键字"
                          variant="outlined"
                          clearable
                      ></v-text-field>
                    </v-col>
                    <v-col cols="1.5">
                      <v-select
                          ref="operatorListRef"
                          v-model="formData.locationId"
                          :items="serviceLocationData"
                          item-title="locationName"
                          item-value="locationId"
                          label="服务地点"
                          variant="outlined"
                          :no-data-text="'没有更多数据了~'"
                          @update:modelValue="handleSelectServiceLocation"
                          :loading="serviceLocationLoading"
                          placeholder="请选择服务地点"
                          @update:menu="handleClickSelect"
                      >
                        <template v-slot:prepend-item>
                          <div class="pd_l_1 pd_r_1 pd_t_1" style="width: 300px">
                            <v-text-field
                                v-model="serviceLocationKey"
                                placeholder="请输入服务地点名称"
                                label="服务地点名称"
                                variant="outlined"
                                clearable
                                append-inner-icon="mdi-magnify"
                                @click:append-inner="handleGetServiceLocationList('search')"
                                @keydown.enter="handleGetServiceLocationList('search')"
                                :disabled="serviceLocationLoading"
                            ></v-text-field>
                          </div>
                          <v-divider class="mb-2"></v-divider>
                        </template>
                        <template v-slot:append-item>
                          <v-divider class="mb-2" v-if="serviceLocationTotal > 0"></v-divider>
                          <YTTablePagination v-show="serviceLocationTotal > 0" ref="YTTablePaginationServiceLocationRef" :pageSize="5" :total="serviceLocationTotal" @page-change="handleChangeServiceLocationPage"></YTTablePagination>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="1.5">
                      <v-select
                          v-model="formData.startTime"
                          :model-value="formData.startTime ? handleDateFormat(formData.startTime) : null"
                          label="开始日期"
                          variant="outlined"
                          placeholder="请选择开始日期"
                          :menu-props="{maxHeight: '550px'}"
                      >
                        <template v-slot:no-data style="max-height: 550px">
                          <div class="flex_center" style="position: relative">
                            <v-date-picker color="#ED5513" title="选择开始日期" :hide-header="false" locale="zh-cn" @update:modelValue="handleSelectDate" v-model="formData.startTime" show-adjacent-months>
                              <template #header>
                                <div class="text-h4" style="box-sizing: border-box;padding: 0 12px 12px 24px"> {{ formData.startTime ? handleDateFormat(formData.startTime) : "请选择开始日期" }}</div>
                              </template>
                            </v-date-picker>
                          </div>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="1.5">
                      <v-select
                          v-model="formData.endTime"
                          :model-value="formData.endTime ? handleDateFormat(formData.endTime) : null"
                          label="结束日期"
                          variant="outlined"
                          placeholder="请选择结束日期"
                          :menu-props="{maxHeight: '550px'}"
                      >
                        <template v-slot:no-data style="max-height: 550px">
                          <div class="flex_center" style="position: relative">
                            <v-date-picker :min="formData.date" color="#ED5513" title="选择结束日期" :hide-header="false" locale="zh-cn" @update:modelValue="handleSelectEndDate" v-model="formData.endTime" show-adjacent-months>
                              <template #header>
                                <div class="text-h4" style="box-sizing: border-box;padding: 0 12px 12px 24px"> {{ formData.endTime ? handleDateFormat(formData.endTime) : "请选择结束日期" }}</div>
                              </template>
                            </v-date-picker>
                          </div>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="1.5">
                      <v-select
                          ref="operatorListRef"
                          v-model="formData.providerId"
                          :items="therapistList"
                          item-title="name"
                          item-value="providerId"
                          label="服务人员"
                          variant="outlined"
                          :no-data-text="'没有更多数据了~'"
                          @update:modelValue="handleSelectProvider"
                          placeholder="请选择服务人员"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="1.5">
                      <v-select
                          ref="operatorListRef"
                          v-model="formData.orderState"
                          :items="serviceItemOrderState"
                          item-title="stateName"
                          item-value="stateId"
                          label="订单状态"
                          variant="outlined"
                          :no-data-text="'没有更多数据了~'"
                          @update:modelValue="handleSelectOrderState"
                          placeholder="请选择订单状态"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="3">
                      <v-row justify="end">
                        <v-col class="flex_right" cols="6">
                          <v-btn color="success" size="large" @click="handleSearch('btnSearch')">搜索
                          </v-btn>
                        </v-col>
                        <v-col class="flex_right" cols="6">
                          <v-btn size="large" @click="handleReset">重置
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
              <div class="flex_right mg_b_1">
                <v-btn
                    :disabled="serviceItemName === null"
                    color="#4CAF50"
                    @click="handleDownloadList(drawerCache)"
                >
                  下载列表
                </v-btn>
              </div>
            </template>

            <template v-slot:item.scheduleDate="{item}">
              <div>{{item.scheduleDate}} {{item.startTime}} - {{item.endTime}}</div>
            </template>

            <template v-slot:item.orderState="{item}">
              <div>
                {{ serviceItemOrderState.find(i => i.stateId === item.orderState).stateName }}
              </div>
            </template>

            <template v-slot:item.controls="{ item }">
              <div class="flex_left flex_align_b">
                <el-tooltip
                    class="box-item"
                    effect="dark"
                    content="编辑"
                    placement="top">
                  <v-icon class="cursor-pointer mg_r_1" icon="mdi-file-edit-outline" size="small" color="primary" @click="handleEditOrder(item)"></v-icon>
                </el-tooltip>
              </div>
            </template>

            <template v-slot:bottom>
              <YTTablePagination ref="YTTablePaginationRef" :page-size="$globalPageSizeHalf" :total="total" @page-change="handleChangePage"></YTTablePagination>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </div>
  <el-dialog
      v-model="open"
      width="800"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">{{`${isEdit ? `编辑${dialogForm.providerName} ${dialogForm.startScheduleDate} ${dialogForm.startHour} - ${dialogForm.endHour}` : '新增'}排班`}}</div>
    </template>
    <el-form
        ref="dialogFormRef"
        :model="dialogForm"
        :rules="formData.serviceItemType == 'THERAPY' ? dialogRulesTherapy : dialogRulesPhotography"
        label-width="auto"
        class="demo-ruleForm"
        size="large"
        v-loading="loading">
      <el-form-item label="排班日期：" prop="scheduleDate">
        <div class="flex_left">
          <div class="flex_left" v-if="isEdit">
            <el-date-picker
                v-model="dialogForm.scheduleDate"
                type="date"
                placeholder="排班日期"
                class="mg_r_1"
            />
          </div>
          <div class="flex_left" v-else>
            <el-date-picker
                v-model="dialogForm.startScheduleDate"
                type="date"
                placeholder="开始日期"
                class="mg_r_1"
                @change="() => dialogForm.endScheduleDate = null"
            />
            <div class="mg_r_1">至</div>
            <el-date-picker
                v-model="dialogForm.endScheduleDate"
                type="date"
                placeholder="结束日期"
                :disabled-date="
                  (time) => disabledEndDate(time, dialogForm.startScheduleDate)
                "
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="排班时间：" prop="scheduleTime">
        <el-time-select
            v-model="dialogForm.startHour"
            :max-time="isEdit ? '23:59' : dialogForm.endHour"
            style="width: 220px"
            start="00:00"
            step="01:00"
            end="23:00"
            placeholder="开始时间"
            class="mg_r_1"
            @change="handleAutoEnterEndHour"
        />
        <div class="mg_r_1">至</div>
        <el-time-select
            v-model="dialogForm.endHour"
            :min-time="dialogForm.startHour"
            style="width: 220px"
            start="00:59"
            step="01:00"
            end="23:59"
            placeholder="结束时间"
            :disabled="isEdit"
        />
      </el-form-item>
      <template v-if="formData.serviceItemType == 'THERAPY'">
        <el-form-item label="酒店：" prop="locationId">
          <el-select class="mg_r_1" :loading="hotelLoading" v-model="dialogForm.locationId" style="width: 250px;" placeholder="请选择">
            <el-option
                v-for="item in hotelList"
                :key="item.locationId"
                :label="item.locationName"
                :value="item.locationId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="理疗师：" prop="providerId">
          <el-select class="mg_r_1" remote-show-suffix filterable remote :remote-method="handleGetTherapistList" :loading="therapistLoading" v-model="dialogForm.providerId" style="width: 250px;" placeholder="请选择">
            <el-option
                v-for="item in therapistList"
                :key="item.providerId"
                :label="item.name"
                :value="item.providerId">
            </el-option>
          </el-select>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="服务摄影师：" prop="photographyId">
          <el-select class="mg_r_1" :loading="servicePhotographyLoading" v-model="dialogForm.photographyId" style="width: 250px;" placeholder="请选择">
            <el-option
                v-for="item in servicePhotographyList"
                :key="item.photographyId"
                :label="item.photographyName"
                :value="item.photographyId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="摄影师：" prop="providerId">
          <el-select class="mg_r_1" remote-show-suffix filterable remote :remote-method="handleGetPhotographyList" :loading="photographyLoading" v-model="dialogForm.providerId" style="width: 250px;" placeholder="请选择">
            <el-option
                v-for="item in photographyList"
                :key="item.providerId"
                :label="item.name"
                :value="item.providerId">
            </el-option>
          </el-select>
        </el-form-item>
      </template>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <v-row>
          <v-col cols="5" offset="7">
            <div class="flex_right">
              <v-btn variant="elevated" @click="handleCloseDialog">取消</v-btn>
              <el-popconfirm @confirm="handleRemoveSchedule(item)" :title="`确定删除排班？`">
                <template #reference>
                  <v-btn v-if="isEdit" class="mg_l_1" color="error" variant="elevated">删除排班</v-btn>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
              <v-btn class="mg_l_1" color="primary" variant="elevated" @click="handleSubmitDialog">确定</v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </el-dialog>
  <el-dialog
      v-model="openOrder"
      width="800"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">编辑订单{{orderForm.orderId}}信息</div>
    </template>
    <el-form
        ref="orderFormRef"
        :model="orderForm"
        :rules="orderRules"
        label-width="auto"
        class="demo-ruleForm"
        size="large"
        v-loading="loading">
      <el-form-item label="会员名称：">
        {{orderForm.contactName}}
      </el-form-item>
      <el-form-item label="服务地点：">
        <el-select
            v-model="orderForm.locationId"
            placeholder="服务地点" style="width: 240px"
            @change="handleLocationChange">
          <el-option
              v-for="item in hotelList"
              :key="item.locationId"
              :label="item.locationName"
              :value="item.locationId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="服务时间：">
        <el-date-picker
            v-model="orderForm.scheduleDate"
            type="date"
            placeholder="服务日期"
            class="mg_r_1"
            @change="handleScheduleDateChange"
            :disabled-date="disabledDate"
        />
        <el-select
           class="mg_r_1"
           style="width: 140px"
           :disabled="!orderForm.scheduleDate"
           @change="handleStartTimeChange"
           v-model="orderForm.startHour"
           placeholder="开始时间">
          <el-option
              v-for="(item, index) in formattedTimes"
              :key="index"
              :label="`${item.startHour}`"
              :value="item.startHour"
          />
        </el-select>
        <el-time-select
            v-model="orderForm.endHour"
            style="width: 140px"
            start="00:00"
            step="01:00"
            end="23:59"
            :disabled="true"
            placeholder="结束时间"
        />
      </el-form-item>
      <el-form-item label="当前房间号：">
        {{orderForm.roomNumber}}
      </el-form-item>
      <el-form-item class="mg_b_3" label="更改房间号：" prop="changeRoomNumber">
        <el-input style="width: 240px" v-model="orderForm.changeRoomNumber" placeholder="房间号"/>
      </el-form-item>
      <el-form-item label="当前服务人员：">
        {{orderForm.providerName}}
      </el-form-item>
      <el-form-item label="更改服务人员：" prop="changeProviderId">
        <el-select v-model="orderForm.changeProviderId" placeholder="服务人员" style="width: 240px">
          <el-option
              v-for="item in therapistList"
              :key="item.providerId"
              :label="item.name"
              :value="item.providerId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="更改订单状态：" prop="orderState">
        <el-select v-model="orderForm.orderState" placeholder="订单状态" style="width: 240px">
          <el-option
              v-for="item in serviceItemOrderState"
              :key="item.stateId"
              :label="item.stateName"
              :value="item.stateId"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <v-row>
          <v-col cols="5" offset="7">
            <div class="flex_right">
              <v-btn variant="elevated" @click="handleCloseOrder">取消</v-btn>
              <v-btn class="mg_l_1" color="primary" variant="elevated" @click="handleSubmitOrder">确定</v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
.vuecal__schedule--heading {font-size: 11px;}
.vuecal__body .schedule1 {background-color: rgba(226, 242, 253, 0.7);}
.vuecal__body .schedule2 {background-color: rgba(232, 245, 233, 0.7);}
.vuecal__body .schedule3 {background-color: rgba(255, 243, 224, 0.7);}
.vuecal__body .schedule4 {background-color: rgba(255, 235, 238, 0.7);}
</style>
